import { render, staticRenderFns } from "./PainAssessment.vue?vue&type=template&id=28c6f272&scoped=true"
import script from "./PainAssessment.vue?vue&type=script&lang=js"
export * from "./PainAssessment.vue?vue&type=script&lang=js"
import style0 from "./PainAssessment.vue?vue&type=style&index=0&id=28c6f272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6f272",
  null
  
)

export default component.exports